import { useCallback } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

/**
 * Low-level hook around Google reCAPTCHA v3 execute.
 * Prefer useRecaptchaToken from recaptchaUtils for form submissions.
 */
const useRecaptchaV3 = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const getRecaptchaToken = useCallback(
    async (action = 'submit') => {
      if (!executeRecaptcha) {
        console.warn('reCAPTCHA not loaded yet');
        return null;
      }

      try {
        return await executeRecaptcha(action);
      } catch (error) {
        console.error('reCAPTCHA error:', error);
        return null;
      }
    },
    [executeRecaptcha]
  );

  return { getRecaptchaToken, isReady: Boolean(executeRecaptcha) };
};

export default useRecaptchaV3;
